export default class VideoException extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'VideoException';
  }
}
